import {API_URL} from "../../../../constants/constants";

export const FORGOT_PASSWORD = '[Forgot Password]'
export const RESET_PASSWORD = '[Reset Password]'

export const POST_FORGOT_PASSWORD = `${FORGOT_PASSWORD} Post`
export const POST_FORGOT_PASSWORD_SUCCESS = `${FORGOT_PASSWORD} Success`
export const POST_FORGOT_PASSWORD_FAILED = `${FORGOT_PASSWORD} Failed`

export const POST_RESET_PASSWORD = `${RESET_PASSWORD} Post`
export const POST_RESET_PASSWORD_SUCCESS = `${RESET_PASSWORD} Success`
export const POST_RESET_PASSWORD_FAILED = `${RESET_PASSWORD} Failed`

// Extract base URL from API_URL (remove /api/v1)
const PASS_BASE_URL = API_URL.startsWith('/') ? '' : new URL(API_URL).origin

export const postForgotPassword = ({email, callback_url}) => ({
    type: POST_FORGOT_PASSWORD,
    payload: {
        data: `${PASS_BASE_URL}/auth/password/forgot`,
        body: {
            email,
            callback_url
        }
    }
})

export const postForgotPasswordSuccess = () => ({
    type: POST_FORGOT_PASSWORD_SUCCESS
})

export const postForgotPasswordFailed = () => ({
    type: POST_FORGOT_PASSWORD_FAILED
})

export const postResetPassword = ({email, password, password_confirmation, token}) => ({
    type: POST_RESET_PASSWORD,
    payload: {
        data: `${PASS_BASE_URL}/auth/password/reset`,
        body: {
            email,
            password,
            password_confirmation,
            token
        }
    }
})

export const postResetPasswordSuccess = () => ({
    type: POST_RESET_PASSWORD_SUCCESS
})

export const postResetPasswordFailed = () => ({
    type: POST_RESET_PASSWORD_FAILED
})
